// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
import { db } from '@/shared/firebase/firebase-init';
const SIZE = 10;

const KEY_USERS_MANAGER="usersManager"

export default {
  fetch(lastmodified) {
    return new Promise((resolve) => {
      console.log(lastmodified);
      
      db.ref("log")
        .child("logs")
        .child(KEY_USERS_MANAGER)
        .orderByChild("modified")
        .endAt(lastmodified-1)
        .limitToLast(SIZE)
        .once('value').then((snapshot) => { 
        var list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });
        
        const result =  {
          data: list.reverse(),
          last: list.length < SIZE
        }

        resolve(result)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/manager/manager-history/manager-history-full/manager-history-full-service.js